export default "__VITE_ASSET__C8WWcMdZ__"